import { render } from "./DateChoice.vue?vue&type=template&id=28a966e0"
import script from "./DateChoice.vue?vue&type=script&lang=js"
export * from "./DateChoice.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__